import { Tabs } from '@mui/material'
import { COLORS } from 'utils'

import { TabCustom } from './Tab.styles'
interface TabProps {
  tabs: string[]
  value: any
  handleChange?: any
  onClick?: any
}
export const Tab: React.FC<TabProps> = ({
  tabs,
  value,
  handleChange,
  onClick
}) => {
  return (
    <Tabs
      onClick={onClick || null}
      onChange={handleChange}
      scrollButtons="auto"
      variant="scrollable"
      value={value}
      TabIndicatorProps={{ style: { background: COLORS.primary } }}
    >
      {tabs.map((tab, index) => (
        <TabCustom
          key={tab}
          id={`${tab}-${index}`}
          label={tab}
          backgroundColor={
            Object.is(value, index) ? COLORS.primary : 'transparent'
          }
          style={{ color: COLORS.black }}
        />
      ))}
    </Tabs>
  )
}
